import AuthGuard from './components/global/AuthGuard';
import GuestGuard from './components/global/GuestGuard';
import NotFound from './components/global/NotFound';
import NotFoundLogin from './components/global/NotFoundLogin';
import DashboardLayout from './components/layouts/DahboardLayout';
import LoginLayout from './components/layouts/LoginLayout';
import Gauge from './pages/admin/gauge/Gauge';
import Upload from './pages/admin/upload/Upload';
import Login from './pages/auth/Login';
import Recovery from './pages/auth/Recovery';
import AvanceAcumulado from './pages/dashboard/avance/AvanceAcumulado';
import AvanceMensual from './pages/dashboard/avance/AvanceMensual';
import CompraDeuda from './pages/dashboard/compra-deuda';
import CurvaProduccion from './pages/dashboard/curva-produccion/CurvaProduccion';
import Evolutivo from './pages/dashboard/evolutivo/Evolutivo';
import GestionOperativa from './pages/dashboard/gestion-operativa';
import GestionSubgerenteJdn from './pages/dashboard/gestion-subgerente-jdn';
import Home from './pages/dashboard/home';
import KpiRemesa from './pages/dashboard/kpi/KpiRemesa';
import KpiTuberia from './pages/dashboard/kpi/KpiTuberia';
import Prospeccion from './pages/dashboard/prospeccion/Prospeccion';
import Proyeccion from './pages/dashboard/proyeccion/Proyeccion';
import SeguimientoOficina from './pages/dashboard/seguimiento-oficina/SeguimientoOficina';
import SeguimientoTerritorio from './pages/dashboard/seguimiento-territorio/SeguimientoTerritorio';
import Seguimiento from './pages/dashboard/seguimiento/Seguimiento';

const routes = [
  {
    path: '/admin',
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '/admin/home',
        element: <Home />,
      },
      {
        path: '/admin/prospeccion',
        element: <Prospeccion />,
      },
      {
        path: '/admin/seguimiento',
        element: <Seguimiento />,
      },
      {
        path: '/admin/seguimiento-oficina',
        element: <SeguimientoOficina />,
      },
      {
        path: '/admin/seguimiento-territorio',
        element: <SeguimientoTerritorio />,
      },
      {
        path: '/admin/proyeccion',
        element: <Proyeccion />,
      },
      {
        path: '/admin/avance-acumulado',
        element: <AvanceAcumulado />,
      },
      {
        path: '/admin/avance-mensual',
        element: <AvanceMensual />,
      },
      {
        path: '/admin/kpi-tuberia',
        element: <KpiTuberia />,
      },
      {
        path: '/admin/kpi-remesa',
        element: <KpiRemesa />,
      },
      {
        path: '/admin/evolutivo',
        element: <Evolutivo />,
      },
      {
        path: '/admin/upload',
        element: <Upload />,
      },
      {
        path: '/admin/gauge',
        element: <Gauge />,
      },
      {
        path: '/admin/curva-produccion',
        element: <CurvaProduccion />,
      },
      {
        path: '/admin/gestion-operativa',
        element: <GestionOperativa />,
      },
      {
        path: '/admin/gestion-subgerente-jdn',
        element: <GestionSubgerenteJdn />,
      },
      {
        path: '/admin/compra-deuda',
        element: <CompraDeuda />,
      },
      {
        path: '/admin/*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/',
    element: (
      <GuestGuard>
        <LoginLayout />
      </GuestGuard>
    ),
    children: [
      {
        path: '/',
        element: <Login />,
      },
      {
        path: '/password-recovery',
        element: <Recovery />,
      },
      {
        path: '/*',
        element: <NotFoundLogin />,
      },
    ],
  },
];

export default routes;
